<div class="flex flex-col gap-8 animate-fadeIn">
  <!-- Header -->
  <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
    <div class="w-full sm:w-80">
      <p-iconField iconPosition="left">
        <p-inputIcon styleClass="pi pi-search"></p-inputIcon>
        <input 
          [formControl]="searchControl"
          type="text" 
          pInputText
          class="!w-full !rounded-2xl !bg-slate-50/50 !border-slate-100 !pl-12 !py-3 !text-sm focus:!ring-primary/10 focus:!border-primary transition-all"
          [placeholder]="'agenda_name_placeholder' | translate" 
        />
      </p-iconField>
    </div>

    <!-- Add Button -->
    <app-button *hasPermission="'Configurações:create'"
      [label]="'settings_profile_new' | translate"
      icon="pi pi-plus"
      (onClick)="onAddProfile()"
      class="w-full sm:w-auto"
    ></app-button>
  </div>

  <!-- Table -->
  <app-prime-table
    [columns]="columns"
    [data]="profiles"
    [loading]="loading"
    [templates]="templates"
    [paginator]="false"
  >
    <ng-template #dateTpl let-item let-col="col">
       <span class="text-xs font-semibold text-slate-500">{{ (item[col.field] | date:'dd/MM/yyyy') || '-' }}</span>
    </ng-template>

    <ng-template #nameTpl let-item>
       <div class="flex items-center gap-2.5">
          <span class="text-sm font-bold text-slate-700">{{ item.name }}</span>
          <span *ngIf="item.is_default"
                class="inline-flex items-center gap-1 text-[9px] font-black uppercase tracking-wider text-primary bg-primary/10 border border-primary/20 px-2 py-0.5 rounded-full shrink-0">
             <i class="pi pi-shield !text-[9px]"></i>
             {{ 'settings_profile_default_badge' | translate }}
          </span>
       </div>
    </ng-template>

    <ng-template #actionsTpl let-item>
       <div class="flex justify-end">
          <app-dropdown>
            <ng-template #trigger>
              <button class="p-2 text-slate-400 hover:text-primary hover:bg-primary/5 rounded-xl transition-all">
                 <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="1"></circle><circle cx="12" cy="5" r="1"></circle><circle cx="12" cy="19" r="1"></circle></svg>
              </button>
            </ng-template>
            <ng-template #content>
              <div class="w-48 py-2">
                 <!-- View users -->
                 <button (click)="onView(item)" class="w-full text-left px-4 py-3 text-[10px] font-black uppercase tracking-widest text-slate-600 hover:bg-slate-50 flex items-center gap-3 transition-colors">
                    <i class="pi pi-eye text-slate-400"></i>
                    {{ 'settings_profile_view' | translate }}
                 </button>
                 <!-- Edit (custom profiles) / View permissions (default roles) -->
                 <button *ngIf="item.is_default || canEdit" (click)="item.is_default ? onViewPermissions(item) : onEdit(item)" class="w-full text-left px-4 py-3 text-[10px] font-black uppercase tracking-widest text-slate-600 hover:bg-slate-50 flex items-center gap-3 transition-colors">
                    <i class="pi text-primary" [ngClass]="item.is_default ? 'pi-shield' : 'pi-pencil'"></i>
                    {{ (item.is_default ? 'settings_profile_view_permissions' : 'settings_profile_edit') | translate }}
                 </button>
                 <!-- Delete (custom profiles only) -->
                 <button *ngIf="!item.is_default && canDelete" (click)="openDeleteModal(item)" class="w-full text-left px-4 py-3 text-[10px] font-black uppercase tracking-widest text-rose-600 hover:bg-rose-50 flex items-center gap-3 transition-colors border-t border-slate-50">
                    <i class="pi pi-trash text-rose-500"></i>
                    {{ 'settings_profile_delete' | translate }}
                 </button>
              </div>
            </ng-template>
          </app-dropdown>
       </div>
    </ng-template>
  </app-prime-table>
</div>

<!-- Delete Confirmation Modal -->
<p-dialog 
  [(visible)]="showDeleteModal" 
  [modal]="true" 
  [draggable]="false" 
  [resizable]="false"
  [closable]="false"
  styleClass="!rounded-3xl overflow-hidden"
  header=" "
>
  <div class="p-8 w-full max-w-sm flex flex-col gap-6">
    <div class="flex flex-col items-center gap-4 text-center">
      <div class="w-16 h-16 rounded-full bg-rose-50 flex items-center justify-center text-rose-500">
        <i class="pi pi-trash text-3xl"></i>
      </div>
      <div class="flex flex-col gap-1">
        <h3 class="text-lg font-bold text-slate-800">{{ 'settings_profile_delete' | translate }}</h3>
        <p class="text-sm text-slate-500">{{ 'settings_profile_delete_confirmation' | translate }}</p>
      </div>
    </div>
    <div class="flex gap-4 pt-2">
      <app-button
        [label]="'cancel' | translate"
        variant="secondary"
        (onClick)="closeDeleteModal()"
        class="flex-1"
      ></app-button>
      <app-button
        [label]="'settings_profile_delete' | translate"
        [variant]="'danger'"
        (onClick)="confirmDelete()"
        class="flex-1"
      ></app-button>
    </div>
  </div>
</p-dialog>

<!-- View Users Modal -->
<app-access-profile-users-modal
  *ngIf="showViewModal"
  [profileId]="selectedProfileForView?.id"
  [profileName]="selectedProfileForView?.name"
  [branchId]="branchId"
  (close)="closeViewModal()"
></app-access-profile-users-modal>

<!-- Profile Settings Modal (Add/Edit) -->
<app-profile-settings-modal
  *ngIf="showProfileModal"
  [profileId]="selectedProfileForEdit?.id"
  [branchId]="branchId"
  [readOnly]="modalReadOnly"
  (close)="closeProfileModal()"
  (saved)="onProfileSaved()"
></app-profile-settings-modal>
